export const FileFormat = {
  PDF: 'PDF',
  JPEG: 'JPEG',
  HTML: 'HTML'
};



// WEBPACK FOOTER //
// ./src/services/api/dto/fileFormat.js